export enum ChannelType {
	Voice = 0,
	Generic = 1,
	Email = 2,
	WhatsApp = 3,
	Webchat = 4,
}

export enum GenericChannelType
{
	Email = 0,
	Chat = 1,
	WhatsApp = 2,
	SocialMedia = 3,
	Generic = 4
}

export enum AcsClientType {
	Teams = "Teams",
	CCaaS = "CCaaS",
	TeamsAndCCaaS = "TeamsAndCCaaS",
}

export enum PlatformType {
	Acs = "Acs",
	Graph = "Graph",
}

export enum AcsErrorCode {
	Declined = 603,
	MissingPolicy = 41056,
}